module.exports = __webpack_public_path__ + "assets/img/NPC044.34a27fd0.png";